<template>
  <div id="container">
    <div v-for="(bubble, index) in bubbles" :key="index" class="bubble-wrapper" @click="handleClick(bubble)"
      :style="bubble.styleWrapper">
      <div class="bubble" :style="bubble.style">
        {{ bubble.text }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  list: {
    type: Array,
    default: () => {
      return []
    }
  }
})

const colors = [
  'linear-gradient(180.00deg, rgb(0, 206, 139),rgb(0, 160, 108) 100%)',
  'linear-gradient(180.00deg, rgb(228, 25, 164),rgb(156, 0, 134) 100%)',
  'linear-gradient(180.00deg, rgb(255, 180, 41),rgb(255, 122, 0) 96.947%)',
  'linear-gradient(180.00deg, rgb(70, 137, 255),rgb(14, 93, 232) 100%)',
  'linear-gradient(180.00deg, rgb(61, 207, 233),rgb(14, 141, 164) 100%)'
]

const bubbles = ref([])

onMounted(() => {
  const containerWidth = 1000
  const containerHeight = 400
  const used = []
  function isOverlapping(x, y, w, h) {
    return used.some(pos => {
      return !(
        x + w < pos.x ||
        x > pos.x + pos.width ||
        y + h < pos.y ||
        y > pos.y + pos.height
      )
    })
  }
  bubbles.value = props.list.map((item, i) => {
    const fontSize = 12 + Math.floor(Math.random() * 5) // 10–14
    const backgroundColor = colors[i % colors.length]
    // 临时 DOM 用于测量尺寸
    const tempEl = document.createElement('div')
    tempEl.style.position = 'absolute'
    tempEl.style.fontSize = fontSize + 'px'
    tempEl.style.padding = '10px 16px'
    tempEl.style.fontWeight = 'bold'
    tempEl.style.borderRadius = '20px'
    tempEl.style.lineHeight = '1'
    tempEl.style.animation = `float-${i} ${8 + Math.random() * 4}s ease-in-out infinite alternate`
    tempEl.innerText = item.topic
    document.body.appendChild(tempEl)
    const w = tempEl.offsetWidth
    const h = tempEl.offsetHeight
    document.body.removeChild(tempEl)

    const dx = Math.random() * 40 - 20
    const dy = Math.random() * 40 - 20
    const duration = 8 + Math.random() * 4

    // 动态注入动画
    const styleEl = document.createElement('style')
    styleEl.innerHTML = `
          @keyframes float-${i} {
              0% { transform: translate(0, 0); }
              100% { transform: translate(${dx}px, ${dy}px); }
          }
      `
    document.head.appendChild(styleEl)
    // 计算气泡位置
    let x, y, tries = 0
    do {
      x = Math.random() * (containerWidth - w)
      y = Math.random() * (containerHeight - h)
      tries++
    } while (isOverlapping(x, y, w, h) && tries < 300)

    if (tries < 300) {
      used.push({ x, y, width: w, height: h })
    }
    return {
      text: item.topic,
      styleWrapper: {
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
      },
      style: {
        position: 'relative',
        padding: '10px 16px',
        borderRadius: '20px',
        color: '#fff',
        fontWeight: 'bold',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        lineHeight: '1',
        fontSize: fontSize + 'px',
        background: backgroundColor,
        animation: `float-${i} ${duration}s ease-in-out infinite alternate`,
      }
    }
  })
})

const handleClick = (bubble) => {
    let path = `https://www.n.cn?q=${bubble.text}`
    window.open(path, '_blank')
}

</script>

<style lang="scss" scoped>
#container {
  position: relative;
  width: 1000px;
  height: 400px;
}

.bubble-wrapper {
  transition: transform 0.3s ease;
  will-change: transform;
}

.bubble-wrapper:hover {
  transform: scale(1.2);
  z-index: 10;
}
</style>